var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluidService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.436 30.588a3.522 3.522 0 0 1-7.044 0c0-1.945 3.521-5.937 3.521-5.937s3.523 3.992 3.523 5.937z",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.827 15.043v29.508a1.56 1.56 0 0 1-1.652 1.446h-24.52c-.91 0-1.655-.648-1.655-1.446V15.264a1.468 1.468 0 0 1 1.068-1.35l15.235-3.56a.622.622 0 0 0 .214-.2h5.876v.135a1.403 1.403 0 0 0 .712 1.197l3.978 2.346a1.4 1.4 0 0 1 .744 1.211z",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.116 16.265H15.712c-.907 0-1.642.735-1.642 1.641v22.949c0 .906.735 1.641 1.641 1.641h18.405c.906 0 1.641-.735 1.641-1.642V17.907c0-.906-.735-1.641-1.641-1.641zM27.517 10.154V5.389A1.389 1.389 0 0 1 28.906 4h3.151a1.393 1.393 0 0 1 1.39 1.424l-.065 4.894M33.428 7.43h-5.57",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluidService);
export default __webpack_public_path__ + "static/media/fluid-service.e2f611b51fdbe95b2effc11cb5e946b2.svg";
export { ForwardRef as ReactComponent };